import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ThemePreference = 'light' | 'dark' | 'system'

interface UIState {
  sidebarCollapsed: boolean
  commandPaletteOpen: boolean
  shortcutsHelpOpen: boolean
  theme: ThemePreference
  setSidebarCollapsed: (collapsed: boolean) => void
  toggleSidebar: () => void
  openCommandPalette: () => void
  closeCommandPalette: () => void
  toggleCommandPalette: () => void
  openShortcutsHelp: () => void
  closeShortcutsHelp: () => void
  toggleShortcutsHelp: () => void
  setTheme: (theme: ThemePreference) => void
}

export const useUIStore = create<UIState>()(
  persist(
    (set, get) => ({
      sidebarCollapsed: false,
      commandPaletteOpen: false,
      shortcutsHelpOpen: false,
      theme: 'system',
      setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
      toggleSidebar: () => set({ sidebarCollapsed: !get().sidebarCollapsed }),
      openCommandPalette: () => set({ commandPaletteOpen: true }),
      closeCommandPalette: () => set({ commandPaletteOpen: false }),
      toggleCommandPalette: () => set({ commandPaletteOpen: !get().commandPaletteOpen }),
      openShortcutsHelp: () => set({ shortcutsHelpOpen: true }),
      closeShortcutsHelp: () => set({ shortcutsHelpOpen: false }),
      toggleShortcutsHelp: () => set({ shortcutsHelpOpen: !get().shortcutsHelpOpen }),
      setTheme: (theme) => set({ theme }),
    }),
    {
      name: 'vela.ui',
      partialize: (s) => ({ sidebarCollapsed: s.sidebarCollapsed, theme: s.theme }),
    },
  ),
)
